var map = {
	"./akashx/akashx.json": 2594,
	"./capturePage/capturePage.json": 9156,
	"./currency/currency.json": 3520,
	"./liveStream/liveStream.json": 4166,
	"./liveStream/timezones.json": 9904,
	"./profileCard/profileCard.json": 8488,
	"common/uiVar/akashx/akashx.json": 2594,
	"common/uiVar/capturePage/capturePage.json": 9156,
	"common/uiVar/currency/currency.json": 3520,
	"common/uiVar/liveStream/liveStream.json": 4166,
	"common/uiVar/liveStream/timezones.json": 9904,
	"common/uiVar/profileCard/profileCard.json": 8488
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4488;